export default __webpack_public_path__ + "static/dong-349bffbea77faa9c8e1ebc22318ee2f3.wav";